<template>
  <div v-if="asyncDataStatus_ready">
    <v-row justify="space-between">
      <v-col cols="6" md="3">
        <v-btn color="#0F998E" class="white--text" @click="saveOrder">
          Shrani vrstni red
          <v-icon right dark>mdi-check</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="$router.push({ name: 'MyCompanyLocationsNew' })"
        >
          Nov prostor
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
<v-col  v-if="this.locations.length">
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Prostor
                </th>

                <th></th>
              </tr>
            </thead>
          </template>
        </v-simple-table>
      </v-col>
    <v-row
      v-if="this.locations.length"
      v-dragula="localLocations"
      drake="locations"
    >

      <v-col
        v-for="item in localLocations"
        :key="item.id"
        :data-id="item.id"
        cols="12"
        class="pt-0 pb-0 "
      >
        <TitleOnlyCard
          :style="{ 'border-left': `5px solid ${item.color}` }"
          :title="item.name"
          :draggable="true"
          @delete="
            showDeleteLocationsModal = true;
            deleteLocations = item;
          "
          @edit="
            $router.push({
              name: 'MyCompanyLocationsEdit',
              params: { id: item.id }
            })
          "
        />
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12">
        <p class="text-center">
          Ni rezultatov iskanja. Za dodajanje nove lokacije uporabite gumb desno
          zgoraj.
        </p>
      </v-col>
    </v-row>

    <ConfirmDialog
      title="Brisanje loakcije"
      text="Ali ste prepričani, da želite izbrisati lokacijo? Podatki bodo trajno izbrisani."
      okBtnText="Briši"
      v-model="showDeleteLocationsModal"
      @confirmed="remove(deleteLocations)"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { siIncludes } from '@/utils/str'
import { deleteItem } from '@/utils/crudFunctions'
import ConfirmDialog from '@/components/ConfirmDialog'
import TitleOnlyCard from '@/components/TitleOnlyCard'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    ConfirmDialog,
    TitleOnlyCard
  },
  mixins: [asyncDataStatus],
  data () {
    return {
      filter: '',
      showDeleteLocationsModal: false,
      deleteLocations: null,
      localLocations: []
    }
  },
  computed: {
    locations () {
      return objectToArray(this.$store.state.locations.items)
    },
    filteredLocations () {
      return this.locations.filter(item =>
        siIncludes({ haystack: `${item.name}`, needle: this.filter })
      )
    }
  },
  methods: {
    ...mapActions('locations', [
      'loadItems',
      'deleteItem',
      'updateLocationsOrder'
    ]),
    remove (item) {
      deleteItem(item, this)
    },
    saveOrder () {
      const updates = []
      this.localLocations.forEach((item, i) => {
        updates.push({
          id: item.id,
          sort_order: i + 1
        })
      })
      this.updateLocationsOrder(updates).then(() => {
        /* this.$notify({
          type: 'success',
          text: 'Podatki so bili uspešno shranjeni.'
        }) */
      })
    }
  },
  created () {
    if (!this.$store.state.businessUnits.currentBusinessUnit) {
      this.$notify({
        type: 'error',
        text: 'Potrebna je vsaj ena aktivna poslovna enota'
      })
    } else {
      this.loadItems().then(locations => {
        this.localLocations = this.locations
        this.asyncDataStatus_fetched()
      })
    }
  },
  watch: {
    locations (newLocations) {
      this.localLocations = newLocations
    }
  }
}
</script>
